const route = {
  path: '/liveCode/statistics/:tenant',
  name: 'liveCodeStatistics',
  component: () => import('@/views/liveCode/index'),
  meta: { routeName: '渠道活码统计' }
}
export default route
